import { v4 as uuidv4 } from "uuid";

export const constructPayloadSubmit = (type = "NEW", data) => {
  const { originData, driverId, driverName, driverUsername, driverCabang } =
    data;
  return {
    id: type === "NEW" ? null : originData.id, //kalau save baru kirim null
    driverId: driverId,
    employeeId: driverName.employeeId,
    userId: driverName.value,
    driverUsername: driverUsername.value,
    driverName: driverName.label,
    driverCabang: driverCabang.map((item) => ({
      refCabangId: item.refCabangId || null,
      kodeCabang: item.value,
    })),
  };
};


export function shortUuid() {
  return Buffer.from(uuidv4().replace(/-/g, ""), "hex")
    .toString("base64")
    .replace(/[^a-zA-Z0-9]/g, "") // hapus karakter non-alnum
    .substring(0, 8);
}